import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import LoginPage from './pages/LoginPage';
import AdminPage from './pages/AdminPage';
import GrowthHubLayout from './components/GrowthHubLayout';
import GrowthHubHome from './pages/GrowthHubHome';
import TacticalsPage from './pages/TacticalsPage';
import FiveStarHome from './pages/FiveStarHome';
import FiveStarReviewPage from './pages/FiveStarReviewPage';
import AdminHub from './pages/AdminHub';
import WhatsNewBanner from './components/WhatsNewBanner';
import ErrorBoundary from './components/ErrorBoundary';
import { Skeleton } from './components/ui/skeleton';
import './App.css';

const LoadingScreen = () => (
  <div className="min-h-screen bg-background flex items-center justify-center">
    <div className="space-y-4 w-64">
      <Skeleton className="h-8 w-48 mx-auto" />
      <Skeleton className="h-4 w-full" />
      <Skeleton className="h-4 w-3/4 mx-auto" />
    </div>
  </div>
);

const ProtectedShell = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  if (loading) return <LoadingScreen />;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return <GrowthHubLayout>{children}</GrowthHubLayout>;
};

const PublicRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  if (loading) return <LoadingScreen />;
  if (isAuthenticated) return <Navigate to="/" replace />;
  return children;
};

const AppContent = () => {
  return (
    <>
      <Routes>
        <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
        <Route path="/admin-legacy" element={<AdminPage />} />

        <Route path="/" element={<ProtectedShell><GrowthHubHome /></ProtectedShell>} />
        <Route path="/tacticals" element={<ProtectedShell><TacticalsPage /></ProtectedShell>} />
        <Route path="/five-star" element={<ProtectedShell><FiveStarHome /></ProtectedShell>} />
        <Route path="/five-star/review/:id" element={<ProtectedShell><FiveStarReviewPage /></ProtectedShell>} />
        <Route path="/admin" element={<ProtectedShell><AdminHub /></ProtectedShell>} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      {/* Mounted ONCE at the app level so the queue survives client-side navigation */}
      <WhatsNewBanner />
    </>
  );
};

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <AppContent />
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
